import { render, staticRenderFns } from "./trainingSingleReport.vue?vue&type=template&id=6135cd1f&scoped=true"
import script from "./trainingSingleReport.vue?vue&type=script&lang=js"
export * from "./trainingSingleReport.vue?vue&type=script&lang=js"
import style0 from "./trainingSingleReport.vue?vue&type=style&index=0&id=6135cd1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135cd1f",
  null
  
)

export default component.exports